import { Component, forwardRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import License from 'app/models/license';
import { UserManagementUser } from 'app/models/user-management-user';
import { LicenseService } from 'app/services/license.service';
import { ModalDirective } from 'ngx-bootstrap/modal';

const noop = () => {};

@Component({
  selector: 'manage-licenses',
  templateUrl: './manage-licenses.component.html',
  styleUrls: ['./manage-licenses.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ManageLicensesComponent),
    multi: true
  }]
})
export class ManageLicensesComponent implements OnInit, OnChanges{

  @Input('user') user: UserManagementUser;

  @ViewChild('licenseModal', { static: true }) public licenseModal: ModalDirective;
  @ViewChild('confirm', { static: true }) confirm: SwalComponent;

  selectedLicense: License;
  public licenses: License[] = [];

  constructor(private licenseService: LicenseService) {}

  ngOnInit(){
    this.licenses = Object.assign([], this.user.licenses);
  }

  ngOnChanges(){
    this.licenses = Object.assign([], this.user.licenses);
  }

  showLicenseModal(event?: Event){
    if(event) event.preventDefault();
    this.licenseModal.show();
  }

  closeLicenseModal(event?: Event){
    if(event) event.preventDefault();
    this.selectedLicense = null;
    this.licenseModal.hide();
  }

  addLicense(event: Event){
    event.preventDefault();
    this.selectedLicense = new License();
    this.showLicenseModal();
  }

  editLicense(event: Event, license: License){
    event.preventDefault();
    this.selectedLicense = license;
    this.showLicenseModal();
  }

  confirmRemoveLicense(event: Event, license: License){
    event.preventDefault();
    this.selectedLicense = license;
    this.confirm.fire();
  }

  removeLicense(){
    this.licenseService.delete(this.user, this.selectedLicense).subscribe(licenses => {
      this.licenses = licenses;
    });

    this.selectedLicense = null;
  }

  saveLicense(event: Event){
    event.preventDefault();

    if(this.selectedLicense.id){
      this.licenseService.update(this.user, this.selectedLicense).subscribe(updatedLicense => {
        this.licenses = this.licenses.map(license => {
          if (license.id === updatedLicense.id) {
            return updatedLicense;
          }

          return license;
        })
      });
    } else {
      this.licenseService.create(this.user, this.selectedLicense).subscribe(license => {
        this.licenses = [...this.licenses, license];
      });
    }

    this.closeLicenseModal();
  }
}
